const l = {
  name: "IsleOfMan",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M8.2,0.4c1.7-1,3.9-0.1,4.4,1.8L14,8.5l2.5,1.9l1.6-4.7l1.4-0.6l4,2l0.1,1.7l-2.6,1.7l-0.5,4.1l0,0
			c-0.3,2-2.3,3-4,2.4l0,0l-5.4-2l-3.4,0.7l2.4,4.8l-0.5,1.4l-5,2l-1.3-1.4l1.4-2.9l-2.7-3.2C0.5,15.1,1,12.9,2.5,12L7,8.5V6.6
			L2.4,8.9L1,8.2l-1-6l1.5-1L4,2.8L8.2,0.4z M12,13.3l5,1.9c0.7,0.2,1.3-0.2,1.4-0.8L19,9.9l0.4-0.7l1.6-1l-1.4-0.7l-1.6,4.9
			l-1.5,0.5l-3.3-2.5L12,11.4V13.3z M10,11.5l-2-1.3l-4.3,3.4l-0.1,0.1c-0.6,0.3-0.6,1-0.3,1.4l0.1,0.1l3.1,3.7l0.1,1.1L6,21.1
			l1.6-0.6l-2.5-5L5.8,14l4.2-0.8V11.5z M10.6,2.7c-0.1-0.6-0.9-0.9-1.4-0.6l0,0L4.5,4.9l-1.1,0L2.4,4.1l0.4,2.4l4.8-2.4L9,5v3.5
			l1.9,1.2L12,8.6L10.6,2.7z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as IsleOfMan
};
